import { useState } from 'react';
import { Container, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import CaseFollowUpList from '../../../Component/Application/CaseFollowUp/CaseFollowUpList';
import CaseFollowUpForm from '../../../Component/Application/CaseFollowUp/CaseFollowUpForm';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Btn } from '../../../AbstractElements';
import { Plus } from 'react-feather';

const CaseFollowUpLawyer = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'active' | 'all' | 'all-relations'>('active');
  const [formModalOpen, setFormModalOpen] = useState(false);

  const handleFormSuccess = () => {
    setFormModalOpen(false);
    // El componente CaseFollowUpList se actualizará automáticamente
    window.location.reload();
  };

  return (
    <div className='page-body'>
      <Breadcrumbs mainTitle={t('Seguimiento de Casos')} parent={t('Aplicaciones')} />
      <Container fluid>
        <Row className="mb-3">
          <Col md="12">
            <div className="d-flex justify-content-between align-items-center">
              <H5 className="mb-0">{t('Mis Casos')}</H5>
              <div className="d-flex align-items-center">
                <Nav tabs className="nav-tabs border-tab me-3">
                  <NavItem>
                    <NavLink
                      className={activeTab === 'active' ? 'active' : ''}
                      onClick={() => setActiveTab('active')}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('Casos Activos')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === 'all' ? 'active' : ''}
                      onClick={() => setActiveTab('all')}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('Todos los Casos')}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === 'all-relations' ? 'active' : ''}
                      onClick={() => setActiveTab('all-relations')}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('Casos con Relaciones')}
                    </NavLink>
                  </NavItem>
                </Nav>
                <Btn color="primary" onClick={() => setFormModalOpen(true)}>
                  <Plus size={16} className="me-1" />
                  {t('Crear Alias')}
                </Btn>
              </div>
            </div>
          </Col>
        </Row>
        <CaseFollowUpList viewType={activeTab} />
        <CaseFollowUpForm
          isOpen={formModalOpen}
          toggle={() => setFormModalOpen(false)}
          onSuccess={handleFormSuccess}
        />
      </Container>
    </div>
  );
};

export default CaseFollowUpLawyer;

